module.exports = __webpack_public_path__ + "static/media/steak.fef59972.svg";